import { render, staticRenderFns } from "./PracticalExamForm.vue?vue&type=template&id=2143fde2"
import script from "./PracticalExamForm.vue?vue&type=script&lang=ts"
export * from "./PracticalExamForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports